import script from "./LotBidsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotBidsList.vue?vue&type=script&lang=ts&setup=true"

import "./LotBidsList.vue?vue&type=style&index=0&id=5e64c270&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e64c270"]])

export default __exports__